import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import isEqual from "lodash/isEqual";
import { RootState } from "@/store";
import { RESET_STATE } from "../actions";

const initialState = { role: { role: "", role_id: "" } } as IUser;

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<IUser | undefined>) => {
            Object.assign(state, { ...action.payload, permissions: state.permissions });
        },
        setCurrentUserPermissions: (state, action: PayloadAction<string[] | undefined>) => {
            // Runs after every API response; reassigning an equal array would re-render every getUser subscriber.
            if (action.payload && !isEqual(state.permissions, action.payload)) {
                state.permissions = action.payload;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(RESET_STATE, () => initialState);
    },
});

export const { setUser, setCurrentUserPermissions } = userSlice.actions;
export default userSlice.reducer;

export const getUser = (state: RootState) => state.user;
export const getUserFirstFacilityId = (state: RootState) => state.user.facilities?.[0]?.facility_id;
export const getUserFirstFacilityName = (state: RootState) => state.user.facilities?.[0]?.facility_name;
